// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__xydpr","content":"content__1qGrD","spinner":"spinner__1a52o"};